import { colors } from '../../core/theme/theme';

export const PROJECT_COLORS = [
  colors.yellow,
  colors.red,
  colors.kronosAccent,
  colors.warmBeige,
  colors.softGreen,
  '#A78BFA',
  '#60A5FA',
  '#F472B6',
  '#FB923C',
  '#34D399',
] as const;

/**
 * Deterministic project→colour mapping. Uses the project's explicit
 * color if set; otherwise hashes projectId to an index.
 */
export function getProjectColor(projectId: string, explicitColor?: string): string {
  if (explicitColor) return explicitColor;
  const hash = projectId.split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return PROJECT_COLORS[hash % PROJECT_COLORS.length];
}
